<template>
  <div id="app">
    <Header />
    <router-view />
    <Contact />
    <Footer />

    <form id="banque" method="POST" action>
      <input type="text" name="PBX_SITE" value />
      <input type="text" name="PBX_RANG" value />
      <input type="text" name="PBX_IDENTIFIANT" value />
      <input type="text" name="PBX_TOTAL" value />
      <input type="text" name="PBX_DEVISE" value />
      <input type="text" name="PBX_CMD" value />
      <input type="text" name="PBX_PORTEUR" value />
      <input type="text" name="PBX_RETOUR" value />
      <input type="text" name="PBX_REPONDRE_A" value />
      <input type="text" name="PBX_EFFECTUE" value />
      <input type="text" name="PBX_ANNULE" value />
      <input type="text" name="PBX_REFUSE" value />
      <input type="text" name="PBX_HASH" value />
      <input type="text" name="PBX_TIME" value />
      <input type="text" name="PBX_HMAC" value />
      <input type="submit" value="Payer maintenant" />
    </form>

  </div>
</template>


<script>
import Header from "@/components/Header.vue";
import Contact from "@/components/Contact.vue";
import Footer from "@/components/Footer.vue";

//import 'materialize-css/dist/css/materialize.min.css'
import "./assets/materialize.css";

import "material-design-icons/iconfont/material-icons.css";
import "./assets/fonts.css";
import "./assets/style.css";

export default {
  components: {
    Header,
    Contact,
    Footer
  }
};
</script>



<style scoped>
#banque {
  display: none;
}
</style>